// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Gl-z","tupacHeader":"Hl-z","tupacHeader2":"Il-z","tupacMenu":"Jl-z","tupacMenu2":"Kl-z","tupacMain":"Ll-z","tupacMain2":"Ml-z"};